import { useAtomValue } from "jotai";

import { useBillingQuery } from "~/graphql/graphql-new.gen";
import { activeSaleIdState } from "~/stores/sales";

import { applyBillingPreview, getBillingPreview } from "./billing-preview";

export const useBilling = () => {
  const activeSaleId = useAtomValue(activeSaleIdState);
  const preview = getBillingPreview();

  const billing = useBillingQuery(
    {
      saleId: activeSaleId ?? "",
    },
    {
      enabled: !!activeSaleId,
      refetchOnWindowFocus: false,
      select: (data) => applyBillingPreview(data.billingV2, preview),
      staleTime: 1000,
    },
  );

  return billing;
};
